<div class="wrapper mat-elevation-z2" [class.horizontal]="variant() === 'horizontal'">
	<!--COLOR INDICATOR-->
	<div class="colorIndicator {{ EventColorMapping[event().eventColor] }}"></div>

	<!--TEXT-->
	<div class="infoWrapper">
		<section class="eventInfo">
			<label class="infoLabel primary">
				@switch (event().eventType) {
					@case (EventType.Simulation) {
						<mat-icon fontIcon="fa-hospital-user" fontSet="fas" inline />
					}
					@case (EventType.Exam) {
						<mat-icon fontIcon="fa-users-class" fontSet="fas" inline />
					}
				}
				<span>{{ event().name }}</span>
			</label>
			<label class="infoLabel secondary">
				<mat-icon fontIcon="fa-calendar-day" fontSet="far" inline />
				{{ event().start | timeRangeLabel: event().end : (T.DATE_FORMAT_LONG_DAY | translate) }}
			</label>
			@if (event().description) {
				<label class="infoLabel secondary description">
					<mat-icon fontIcon="fa-sticky-note" fontSet="far" inline />
					<span>
						{{ event().description }}
					</span>
				</label>
			}
		</section>

		<!--SESSION CARD-->
		@if (activeSession()) {
			<section class="sessionInfo">
				<label class="infoLabel primary">
					<mat-icon fontIcon="fa-cube" fontSet="fas" inline />
					<span>{{ activeSession()!.title }}</span>
				</label>
				<label class="infoLabel secondary">
					<mat-icon fontIcon="fa-clock" fontSet="far" inline />
					{{ activeSession()!.startTime | timeRangeLabel: activeSession()!.plannedEndTime : (T.DATE_FORMAT_TIME | translate) }}
				</label>
			</section>
		}
	</div>

	<div class="stateBar">
		{{ T.EVENT_DETAIL_STATE | translate }}
		<label>{{ event().state | getEventStateStringForCustomer }}</label>
		@if (eventTooltip()) {
			<mat-icon
				class="infoHover"
				[matTooltip]="eventTooltip() | translate"
				matTooltipClass="primary large"
				fontIcon="fa-info-circle"
				fontSet="fa"
			/>
		}
	</div>
</div>

<div class="eventActions">
	<ng-content class="eventActions" select="[eventActions]" />
</div>
